class AppointmentButton {

    constructor() {
        const appointmentButton = document.querySelector('.appointment-button');

        if (appointmentButton.dataset.salonId) {
            this.hideAppointmentButton(appointmentButton);
            this.addClickListenerToAppointmentButton(appointmentButton);
            this.addAppointmentButtonScript(appointmentButton.dataset.salonId, appointmentButton.dataset.salonEmail);
        }
    }

    addClickListenerToAppointmentButton(appointmentButton) {
        if (appointmentButton) {
            appointmentButton.addEventListener('click', this.updateWidgetSrc);
        }
    }

    addAppointmentButtonScript(salonId, salonEmail) {
        const scriptElement = document.createElement('script');
        scriptElement.id = 'scriptmeetaimy';
        scriptElement.setAttribute('data-salonId', salonId);
        scriptElement.setAttribute('data-salonEmail', salonEmail);
        scriptElement.defer = true;
        scriptElement.src = 'https://widget2.meetaimy.com/elements/iframe.js';
        document.body.appendChild(scriptElement);
    }

    hideAppointmentButton(appointmentButton) {
        const screenWidth = window.innerWidth;
        const mobileScreenWidthThreshold = 1200;

        if (appointmentButton) {
            appointmentButton.style.display = screenWidth < mobileScreenWidthThreshold ? 'none' : 'inline-block';
        }
    }

    updateWidgetSrc(e) {
        e.preventDefault();
        const iframeWidget = document.getElementById("ifrmWidget");

        const src = iframeWidget.src;
        let src2 = src.replace("openWidget=null", "openWidget=1");

        if (src2 === src) {
            // If the replacement didn't occur, try the reverse replacement
            src2 = src.replace("openWidget=1", "openWidget=null");
        }

        if (src2) {
            iframeWidget.src = src2;
        }
    }
}

module.exports = AppointmentButton;
